import script from "./notes.vue?vue&type=script&setup=true&lang=js"
export * from "./notes.vue?vue&type=script&setup=true&lang=js"

import "./notes.vue?vue&type=style&index=0&id=3c58b0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c58b0e2"]])

export default __exports__